import { render, staticRenderFns } from "./SmallBottomBigTop.vue?vue&type=template&id=4a71bec6"
import script from "./SmallBottomBigTop.vue?vue&type=script&lang=js"
export * from "./SmallBottomBigTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports